import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import UttamKalakarHeader from './UttamKalakarHeader';
import UttamKalakarFooter from './UttamKalakarFooter';

function ArticleUpload() {

    const navigate = useNavigate();

    const userId = sessionStorage.getItem('userId');

    const [formValues, setFormValues] = useState({
        articletype: '',
        title: ''
    });

    const [coverPage, setCoverPage] = useState(null);
    const [mainDocument, setMainDocument] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // ================= HANDLE INPUT =================
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // ================= FILE VALIDATION =================
    const validateFile = (file, input) => {
        if (!file) return false;

        const maxSize = 5 * 1024 * 1024;

        if (file.size > maxSize) {
            Swal.fire('Error', 'Max file size is 5MB', 'error');
            input.value = '';
            return false;
        }

        const allowed = /(\.doc|\.docx)$/i;
        if (!allowed.test(file.name)) {
            Swal.fire('Error', 'Only .doc/.docx allowed', 'error');
            input.value = '';
            return false;
        }

        return true;
    };

    // ================= FILE HANDLERS =================
    const handleCoverPageUpload = (e) => {
        const file = e.target.files[0];
        if (validateFile(file, e.target)) {
            setCoverPage(file);
        }
    };

    const handleMainDocumentUpload = (e) => {
        const file = e.target.files[0];
        if (validateFile(file, e.target)) {
            setMainDocument(file);
        }
    };

    // ================= FINAL SUBMIT =================
    const handleFinalSubmit = async () => {

        if (!formValues.articletype || !formValues.title) {
            return Swal.fire('Error', 'Please fill manuscript details', 'error');
        }

        if (!coverPage || !mainDocument) {
            return Swal.fire('Error', 'Please upload both files', 'error');
        }

        const useremail = sessionStorage.getItem('loggedInUser');

        const formData = new FormData();
        formData.append('articletype', formValues.articletype);
        formData.append('title', formValues.title);
        formData.append('userId', userId);
        formData.append('useremail', useremail);
        formData.append('coverPage', coverPage);
        formData.append('mainDocument', mainDocument);

        try {
            const response = await axios.post(
                'https://nrdruhs.in/submitArticleFull',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            Swal.fire('Success', response.data.message, 'success')
                .then(() => navigate('/articleimageupload'));

        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Submission failed', 'error');
        }
    };

    return (
        <div>
            <UttamKalakarHeader />

            {/* CENTERED CONTAINER */}
            <div style={{
                paddingTop: 45,
                paddingBottom: 45,
                maxWidth: '700px',
                width: '90%',
                margin: '0 auto'
            }}>

                {/* STEP 1 */}
                <h3 style={{
                    textAlign: 'center',
                    padding: 15,
                    backgroundColor: '#ff2056',
                    color: 'white',
                    borderRadius: '5px'
                }}>
                    Step 1 - Manuscript Details
                </h3>

                <div className="mb-3 mt-3">
                    <label><strong>Article Type</strong></label>
                    <select
                        className="form-control"
                        name="articletype"
                        value={formValues.articletype}
                        onChange={handleChange}
                    >
                        <option value="">Select Article Type</option>
                        <option value="Thesis">Thesis</option>
                        <option value="Original Research">Original Research</option>
                        <option value="Review">Review</option>
                        <option value="Case Report">Case Report</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label><strong>Title</strong></label>
                    <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={formValues.title}
                        onChange={handleChange}
                    />
                </div>

                {/* STEP 2 */}
                <h3 style={{
                    textAlign: 'center',
                    padding: 15,
                    backgroundColor: '#ff2056',
                    color: 'white',
                    borderRadius: '5px',
                    marginTop: '30px'
                }}>
                    Step 2 - Upload Documents
                </h3>

                {/* Cover Page */}
                <div className="card mt-4" style={{ backgroundColor: '#dfdfdf' }}>
                    <div className="card-body text-center">
                        <h5>Cover Page</h5>
                        <input
                            type="file"
                            className="form-control"
                            onChange={handleCoverPageUpload}
                        />
                    </div>
                </div>
                {/* Main Document */}
                <div className="card mt-4" style={{ backgroundColor: '#dfdfdf' }}>
                    <div className="card-body text-center">

                        <h5>Main Document</h5>

                        <input
                            type="file"
                            className="form-control"
                            onChange={handleMainDocumentUpload}
                        />

                        {/* NOTE BOX */}
                        <div
                            style={{
                                marginTop: '10px',
                                backgroundColor: 'red',
                                color: 'white',
                                border: '1px solid white',
                                padding: '10px',
                                fontWeight: 'bold',
                                borderRadius: '5px'
                            }}
                        >
                            NOTE: Upload your Main Document with Images (Mandatory)
                        </div>

                    </div>
                </div>

                {/* FINAL BUTTON */}
                <div className="text-center mt-4">
                    <button
                        className="btn btn-warning"
                        style={{ fontSize: 18, fontWeight: 'bold' }}
                        onClick={handleFinalSubmit}
                    >
                        CONFIRM & SAVE
                    </button>
                </div>

            </div>

            <UttamKalakarFooter />
        </div>
    );
}

export default ArticleUpload;